//import queryString from 'query-string'

export default function useGetRoute({ route_id: routeName, slug, name }, parentRoute = null, localized = true) {
  const { locale } = useI18n();
  let result = null;
  const router = useRouter();

  function parseQueryString(queryString) {
    return queryString
      .slice(1)
      .split('&')
      .reduce((params, param) => {
        const [key, value] = param.split('=');
        params[key] = decodeURIComponent(value.replace(/\+/g, ' '));
        return params;
      }, {});
  }

  // check route
  if (routeName) {
    if (routeName.includes('?')) {
      const [templateName, paramString] = routeName.split('?');
      const params = parseQueryString(paramString);
      //  const params = queryString.parse(paramString)

      result = {
        name: templateName,
        params,
      };
    } else {
      result = {
        name: routeName,
        params: {
          slug: slug[locale],
        },
      };
    }

    // check parent route
  } else if (parentRoute) {
    result = {
      name: parentRoute.replace('___', '-detail___'),
      params: {
        slug: slug[locale],
      },
    };

    // if route doesn't exist -> about page template
    const link = router.resolve(result);

    if (link.href == '/') {
      result = {
        name: 'about-page-slug',
        params: { slug: slug[locale] },
      };
    }

    // -> about-page template
  } else {
    result = {
      name: 'about-page-slug',
      params: { slug: slug[locale] },
    };
  }
  return result;
}
